module.exports = __webpack_public_path__ + "img/features_scorebuilder_phone_mobile2.30dbdd77.jpg";